import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Model from './Model';
import { getModelManager, getUserProfileWidget, getFlowSequenceForModel } from '../../selectors/index';
import {
  postModelThunk,
  describeModelThunk,
  setModelChangeThunk,
  modelCleanUpThunk,
  getModelVariantsThunk,
  setDuplicateChangeThunk,
  getSequenceVersionThunk
} from '../../actions/model';

const mapStateToProps = state => {
  return {
    modelManager: getModelManager(state),
    userProfileWidgets: getUserProfileWidget(state),
    flowSequences: getFlowSequenceForModel(state),
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveModel: (model, widgetCode) => postModelThunk(model, widgetCode),
      describeModel: (modelId, isDuplicate, widgetCode, modelCategoryId) => describeModelThunk(modelId, isDuplicate, widgetCode, modelCategoryId),
      changeModel: selectedModel => setModelChangeThunk(selectedModel),
      modelCleanUp: eventCode => modelCleanUpThunk(eventCode),
      getModelVariants: (modelCategoryId, modelId, offset, limit, filter, organisationId, includeSeqenceList) =>
        getModelVariantsThunk(modelCategoryId, modelId, offset, limit, filter, 'MODELVARIANTLIST', organisationId, includeSeqenceList),
      setDuplicateChange: modelVariants => setDuplicateChangeThunk(modelVariants),
      sequenceVersionListing: (modelVariantId, widgetCode) => getSequenceVersionThunk(modelVariantId, widgetCode)
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Model);
